export default "__VITE_ASSET__d1c861db__"